import type { CurrencyCode } from './types';

/** Currency formatter with 2 decimals — handles the per-customer currency. */
export function money(amount: number, currency: CurrencyCode): string {
  try {
    return new Intl.NumberFormat('en-IE', {
      style: 'currency',
      currency,
      minimumFractionDigits: 2,
      maximumFractionDigits: 2,
    }).format(amount);
  } catch {
    return `${amount.toFixed(2)} ${currency}`;
  }
}

/** Whole-number currency (for the headline stat cards, e.g. €28,450). */
export function moneyShort(amount: number, currency: CurrencyCode = 'EUR'): string {
  try {
    return new Intl.NumberFormat('en-IE', {
      style: 'currency',
      currency,
      maximumFractionDigits: 0,
    }).format(amount);
  } catch {
    return `${Math.round(amount)} ${currency}`;
  }
}

/** Sum the NET (ex-VAT) of an order's three charge buckets. */
export const orderNet = (o: { transport: number | null; fuel: number | null; other: number | null }) =>
  (o.transport ?? 0) + (o.fuel ?? 0) + (o.other ?? 0);
